import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 40 40"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-miterlimit": "10",
  "stroke-width": ".133",
  d: "m30.897 31.128.013-.028.009-.03.008-.03V11.56c0-.01-.007-.021-.01-.033l-.01-.027q-.005-.013-.012-.023l-.018-.032c-.007-.01 0 0 0 0l-1.862-2.607-.016-.016-.023-.027-.023-.02-.026-.019-.027-.014-.029-.015-.027-.008-.032-.009H9.32l-.031.01a.3.3 0 0 0-.083.04c-.007 0-.013.012-.018.016a.3.3 0 0 0-.08.1.2.2 0 0 0-.024.058c0 .009-.005.019-.007.029-.003.01 0 .024 0 .037v19.453l.01.032q.004.015.01.028l.012.022.019.032 1.861 2.607.01.01.036.04.019.016.039.025.021.011a.3.3 0 0 0 .048.018l.018.006a.4.4 0 0 0 .07.008h19.365a.3.3 0 0 0 .084-.014l.02-.005a.4.4 0 0 0 .078-.04l.018-.015.027-.023.02-.025.018-.024zm-1.827-2.855v-18.26l.921 1.289h-.445a.32.32 0 0 0-.339.32.32.32 0 0 0 .34.32h.743v18.045zM9.706 10.01l1.224 1.71v15.648a.32.32 0 1 0 .64 0V11.94h16.227a.32.32 0 0 0 0-.64H11.413L10.01 9.33H28.43v18.725H9.706zM11.25 28.96a.32.32 0 0 0-.32.32v.703l-.92-1.288h18.578l1.404 1.968H11.57V29.28a.32.32 0 0 0-.32-.317z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-miterlimit": "10",
  "stroke-width": ".133",
  d: "M19.72 13.31a.32.32 0 0 0-.452 0l-6.863 6.863a.32.32 0 0 0 .453.453l6.863-6.863a.32.32 0 0 0 0-.453ZM19.335 16.33l-4.27 4.268a.321.321 0 0 0 .35.523.3.3 0 0 0 .103-.07l4.272-4.27a.32.32 0 0 0-.453-.453z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }